// src/js/config/ui/promptForNameModal.js

import { DOMElements } from '../dom.js';
import { getAllOrderConfigs } from '../configLoader.js';
import { escapeHTML } from '../../utils/helpers.js';
import { activateTrap, deactivateTrap } from '../../utils/focusTrap.js';

let currentOnConfirmCallback, currentOnCancelCallback;
let originalTrigger = null;

function showInternalMessage(message) {
    const { promptErrorMessage } = DOMElements;
    if (promptErrorMessage) {
        promptErrorMessage.innerHTML = message;
        promptErrorMessage.classList.add('is-active-error');
        setTimeout(() => {
            promptErrorMessage.classList.remove('is-active-error');
        }, 3000);
    }
}

function hideModal() {
    const { promptNameModal } = DOMElements;
    if (promptNameModal) {
        deactivateTrap();
        if (originalTrigger) originalTrigger.focus();
        promptNameModal.classList.remove('is-visible');
        document.body.classList.remove('modal-open');
        originalTrigger = null;
    }
}

export function showPromptForNameModal(initialName, onConfirm, onCancel) {
    const { promptNameModal, promptNameInput, promptErrorMessage } = DOMElements;
    if (!promptNameModal) return;

    originalTrigger = document.activeElement;
    promptNameInput.value = initialName || '';
    promptErrorMessage.innerHTML = '';
    currentOnConfirmCallback = onConfirm;
    currentOnCancelCallback = onCancel || (() => {});

    promptNameModal.classList.add('is-visible');
    document.body.classList.add('modal-open');
    activateTrap(promptNameModal);

    // Fokus på input-fält är pålitligt och behöver ingen extra logik
    promptNameInput.focus();
}

export function initializePromptForNameModal() {
    const { promptNameModal, promptNameInput, promptNameConfirmBtn } = DOMElements;
    if (!promptNameModal) return;

    const strings = window.SimP_Strings || {};

    promptNameConfirmBtn.addEventListener('click', () => {
        const newName = promptNameInput.value.trim();
        if (newName === "") {
            showInternalMessage(strings.prompt_name_empty || 'Namnet kan inte vara tomt.');
            return;
        }

        const existingConfigs = getAllOrderConfigs();
        const nameExists = existingConfigs.some(config => config.name.toLowerCase() === newName.toLowerCase());

        if (nameExists) {
            const message = (strings.prompt_name_exists || 'Namnet "%s" finns redan.').replace('%s', escapeHTML(newName));
            showInternalMessage(message);
            return;
        }

        hideModal();
        if (typeof currentOnConfirmCallback === 'function') {
            currentOnConfirmCallback(newName);
        }
    });

    // Hantera Avbryt och Enter-tryck
    promptNameModal.addEventListener('click', (e) => {
        if (e.target.closest('#promptNameCancelBtn') || e.target === promptNameModal) {
            hideModal();
            if (typeof currentOnCancelCallback === 'function') {
                currentOnCancelCallback();
            }
        }
    });

    promptNameInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            promptNameConfirmBtn.click();
        } else if (e.key === 'Escape') {
            hideModal();
            if (typeof currentOnCancelCallback === 'function') {
                currentOnCancelCallback();
            }
        }
    });
}